import { render, staticRenderFns } from "./ruleQuery.vue?vue&type=template&id=2affd1c7&scoped=true"
import script from "./ruleQuery.vue?vue&type=script&lang=js"
export * from "./ruleQuery.vue?vue&type=script&lang=js"
import style0 from "./ruleQuery.vue?vue&type=style&index=0&id=2affd1c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2affd1c7",
  null
  
)

export default component.exports